import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';

// Only English (the fallback) ships in the main bundle. Malay/Tamil are ~100KB each and are
// fetched on demand the first time that language is selected or detected.
const resources = {
  en: { translation: en },
};

const LAZY_LOCALES = {
  ms: () => import('./locales/ms.json'),
  tg: () => import('./locales/tg.json'),
};

const initPromise = i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    fallbackNS: 'translation',
    defaultNS: 'translation',
    ns: ['translation'],
    nonExplicitFallbackLng: true,
    returnNull: false,
    returnEmptyString: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

const pending = {};
async function ensureLocale(lng) {
  const code = String(lng || '').toLowerCase().split('-')[0];
  const loader = LAZY_LOCALES[code];
  if (!loader || i18n.hasResourceBundle(code, 'translation')) return;
  pending[code] ??= loader()
    .then((mod) => i18n.addResourceBundle(code, 'translation', mod.default ?? mod, true, true))
    .catch(() => { delete pending[code]; }); // offline: stay on English fallback, retry next time
  await pending[code];
}

// Every caller (AuthContext, language picker) goes through changeLanguage, so wrap it to make
// sure the bundle is present before the switch (and therefore before the re-render).
const originalChangeLanguage = i18n.changeLanguage.bind(i18n);
i18n.changeLanguage = async (lng, ...rest) => {
  await ensureLocale(lng);
  return originalChangeLanguage(lng, ...rest);
};

// Language restored from localStorage/navigator at init: load its bundle, then re-apply it.
initPromise.then(() => {
  const detected = i18n.language;
  if (LAZY_LOCALES[String(detected || '').toLowerCase().split('-')[0]]) {
    i18n.changeLanguage(detected);
  }
});

export default i18n;
